;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export type NotificationType =
  | 'system'
  | 'employees'
  | 'payroll'
  | 'expenses'
  | 'invoices'
  | 'errors'
  // BE notification_categories.value
  | 'teams'
  | 'team_members'
  | 'organisation'
  | 'settings'
  | 'task'
  | 'kyb'
  | 'msa';

export const DEFAULT_NOTIFICATION_TYPE: NotificationType = 'system';

import type { NotificationMetadata } from '@workspace/ui/lib';

export type { NotificationMetadata };

export interface NotificationItem {
  id: number;
  notification_user_id: number;
  type: NotificationType;
  key?: string | null;
  subcategory?: string | null;
  metadata?: NotificationMetadata | null;
  message: string;
  date: string;
  read: boolean;
}

export type NotificationsList = NotificationItem[];

// API Response Types
export interface NotificationTypeResponse {
  id: number;
  name: string;
  value: string;
}

export interface NotificationCategoryResponse {
  id: number;
  name: string;
  value: string;
}

export interface NotificationApiResponse {
  id: number;
  notification_user_id: number;
  key?: string | null;
  notification_key?: string | null;
  subcategory?: string | null;
  metadata?: NotificationMetadata | null;
  title?: string | null;
  body?: string | null;
  type?: NotificationTypeResponse | null;
  category?: NotificationCategoryResponse | null;
  read_at?: string | null;
  is_read?: boolean;
  created_at?: string;
}

export interface UpdateNotificationReadStatusRequest {
  notification_id: number;
  notification_user_id: number[];
  read: boolean;
}

export interface UpdateNotificationReadStatusResponse {
  notification_user_id: number;
  notification_id: number;
  user_id: number;
  read_at: string;
}

export interface BulkUpdateApiResponse {
  data: UpdateNotificationReadStatusResponse[];
}

export interface NotificationsQueryData {
  data: NotificationApiResponse[];
  message: string;
}

// Notification Settings Types
export interface NotificationSetting {
  id: number;
  enabled: boolean;
}

export interface NotificationItemSetting {
  title: string;
  'in-app'?: NotificationSetting | null;
  email?: NotificationSetting | null;
}

export interface NotificationCategory {
  id: number;
  name: string;
  value: string;
  notifications?: NotificationItemSetting[] | null;
  notifications_count: number;
}

export interface UpdateNotificationSettingRequest {
  notification_id: number;
  enabled: boolean;
}
